import { render, staticRenderFns } from "./DetailFilter.vue?vue&type=template&id=1c791c54&scoped=true&"
import script from "./DetailFilter.vue?vue&type=script&lang=js&"
export * from "./DetailFilter.vue?vue&type=script&lang=js&"
import style0 from "./DetailFilter.vue?vue&type=style&index=0&id=1c791c54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c791c54",
  null
  
)

export default component.exports